<template>
  <ux-form
    ref="form"
    :data="formData"
    width="440px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="addLimit"
  >
    <ux-form-item label="AppID" prop="app_id">
      <ux-input
        v-model="formData.app_id"
        :maxlength="10"
        :disabled="formData.id ? true : false"
        :placeholder="$t('HT.addLimit.appID.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLimit.minute')" prop="minute">
      <ux-input v-model="formData.minute" :maxlength="4" :placeholder="$t('HT.addLimit.minute.placeholder')"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLimit.day')" prop="day">
      <ux-input v-model="formData.day" :maxlength="4" :placeholder="$t('HT.addLimit.minute.placeholder')"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLimit.type')" prop="type">
      <ux-select
        v-model="formData.type"
        :options="$opt.messageType"
        :disabled="formData.id ? true : false"
        :placeholder="$t('HT.addLimit.type.placeholder')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="memo">
      <ux-input
        v-model="formData.memo"
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 5 }"
        :maxlength="100"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          app_id: '', // AppID
          minute: '', // 每分钟限制
          day: '', // 每天限制
          type: '', // 消息类型
          memo: '' // 描述
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addLimit()
    };
  }
};
</script>
